<template>
  <v-container fluid>
    <SidebarNavigation />

    <v-card class="pa-1">
      <!-- 🔹 TOP BAR (Search + Action) -->
      <v-row class="pa-4">
        <v-col class="d-flex justify-end align-center">
          <!-- BUTTON -->
          <v-btn color="primary" class="mr-2" @click="openDialogCreate">
            <v-icon left>mdi-plus</v-icon>
            Tambah Data
          </v-btn>

          <!-- SEARCH -->
          <v-text-field
            v-model="pagination.search"
            label="Search"
            append-icon="mdi-magnify"
            dense
            hide-details
            outlined
            style="max-width: 250px"
            @input="debouncedSearch"
          />
        </v-col>
      </v-row>

      <!-- 🔹 TABLE -->
      <v-data-table
        mobile-breakpoint="0"
        fixed-header
        dense
        class="elevation-2 mx-4 mb-4"
        :headers="tableHeaders"
        :items="list"
        :items-per-page.sync="pagination.itemsPerPage"
        :page.sync="pagination.page"
        :sort-by="pagination.sortBy"
        :sort-desc="pagination.sortDesc"
        :server-items-length="total"
        item-key="id"
        @update:page="updateQuery('page', $event)"
        @update:items-per-page="updateQuery('itemsPerPage', $event)"
        @update:sort-by="updateQuery('sortBy', $event)"
        @update:sort-desc="updateQuery('sortDesc', $event)"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-for="item in items" :key="item.id">
              <td class="text-center">{{ item.name }}</td>
              <td class="text-center">{{ item.category_name || "-" }}</td>
              <!-- <td class="text-center">{{ item.brand_name || "-" }}</td> -->
              <!-- <td class="text-center">{{ item.color_name || "-" }}</td> -->
              <!-- <td class="text-center">{{ item.material_name || "-" }}</td> -->
              <!-- <td class="text-center">{{ item.type_asset_name || "-" }}</td> -->

              <!-- NOTE (dibatasi biar gak kepanjangan) -->
              <td class="text-center">
                <span v-if="item.note">
                  {{
                    item.note.length > 30
                      ? item.note.substring(0, 30) + "..."
                      : item.note
                  }}
                </span>
                <span v-else>-</span>
              </td>

              <td class="text-center">
                <v-chip
                  small
                  :color="item.is_active == 1 ? 'green' : 'red'"
                  dark
                >
                  {{ item.is_active == 1 ? "Active" : "Inactive" }}
                </v-chip>
              </td>

              <td class="text-center">
                {{ item.created_by_name || "-" }}
              </td>

              <!-- ACTION -->
              <td class="text-center">
                <div
                  class="d-flex justify-center align-center"
                  style="gap: 6px"
                >
                  <!-- EDIT -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogUpdate(item)"
                      >
                        <v-icon size="18">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>

                  <!-- DELETE -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDialogDelete(item)"
                      >
                        <v-icon size="18">mdi-delete-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Hapus</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-card>

    <!-- ===================== DIALOG: CREATE ITEM ===================== -->
    <v-dialog
      v-model="isDialogOpenCreate"
      max-width="700"
      persistent
      scrollable
    >
      <v-card rounded="lg">
        <!-- HEADER -->
        <v-card-title class="px-6 py-5">
          <div class="d-flex align-center">
            <v-avatar size="42" color="primary" class="mr-3">
              <v-icon color="white"> mdi-package-variant-closed-plus </v-icon>
            </v-avatar>

            <div>
              <div class="text-h6 font-weight-bold">Tambah Item</div>
              <div class="text-caption grey--text">
                Lengkapi data item yang akan ditambahkan
              </div>
            </div>
          </div>

          <v-spacer />

          <v-btn
            icon
            :disabled="isSubmittingCreate"
            @click="isDialogOpenCreate = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <!-- FORM -->
        <v-card-text class="pa-6">
          <v-form v-model="isFormValidCreate">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="name"
                  label="Nama Item"
                  placeholder="Masukkan nama item"
                  prepend-inner-icon="mdi-tag-outline"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Nama item wajib diisi']"
                />
              </v-col>

              <v-col cols="6" md="6">
                <v-autocomplete
                  v-model="selectedCategoryId"
                  :items="listCategory"
                  item-text="name"
                  item-value="id"
                  label="Kategori"
                  prepend-inner-icon="mdi-shape-outline"
                  outlined
                  dense
                  clearable
                />
              </v-col>

              <!-- Aktifkan jika diperlukan -->

              <!--
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedBrandId"
              :items="listBrand"
              item-text="name"
              item-value="id"
              label="Brand"
              prepend-inner-icon="mdi-alpha-b-box-outline"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedColorId"
              :items="listColor"
              item-text="name"
              item-value="id"
              label="Warna"
              prepend-inner-icon="mdi-palette-outline"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedMaterialId"
              :items="listMaterial"
              item-text="name"
              item-value="id"
              label="Material"
              prepend-inner-icon="mdi-texture-box"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedUomId"
              :items="listUom"
              item-text="name"
              item-value="id"
              label="UOM"
              prepend-inner-icon="mdi-ruler"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedTypeAssetId"
              :items="listTypeAsset"
              item-text="name"
              item-value="id"
              label="Tipe Asset"
              prepend-inner-icon="mdi-laptop"
              outlined
              dense
              clearable
            />
          </v-col>
          -->

              <v-col cols="12">
                <v-textarea
                  v-model="note"
                  label="Catatan"
                  placeholder="Tambahkan catatan jika diperlukan"
                  prepend-inner-icon="mdi-note-text-outline"
                  outlined
                  dense
                  rows="3"
                  auto-grow
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />

        <!-- FOOTER -->
        <v-card-actions class="px-6 py-4">
          <v-spacer />

          <v-btn
            text
            color="grey darken-1"
            :disabled="isSubmittingCreate"
            @click="isDialogOpenCreate = false"
          >
            Batal
          </v-btn>

          <v-btn
            color="primary"
            depressed
            :disabled="!isFormValidCreate"
            :loading="isSubmittingCreate"
            @click="submitCreate"
          >
            <v-icon left> mdi-content-save-outline </v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ===================== DIALOG: EDIT ITEM ===================== -->
    <v-dialog v-model="isDialogOpenEdit" max-width="700" persistent scrollable>
      <v-card rounded="lg">
        <!-- HEADER -->
        <v-card-title class="px-6 py-5">
          <div class="d-flex align-center">
            <v-avatar size="42" color="warning" class="mr-3">
              <v-icon color="white"> mdi-pencil-outline </v-icon>
            </v-avatar>

            <div>
              <div class="text-h6 font-weight-bold">Ubah Item</div>
              <div class="text-caption grey--text">
                Perbarui informasi item yang dipilih
              </div>
            </div>
          </div>

          <v-spacer />

          <v-btn
            icon
            :disabled="isSubmittingUpdate"
            @click="isDialogOpenEdit = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <!-- FORM -->
        <v-card-text class="pa-6">
          <v-form v-model="isFormValidUpdate">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="name"
                  label="Nama Item"
                  placeholder="Masukkan nama item"
                  prepend-inner-icon="mdi-tag-outline"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Nama item wajib diisi']"
                />
              </v-col>

              <v-col cols="6" md="6">
                <v-autocomplete
                  v-model="selectedCategoryId"
                  :items="listCategory"
                  item-text="name"
                  item-value="id"
                  label="Kategori"
                  prepend-inner-icon="mdi-shape-outline"
                  outlined
                  dense
                  clearable
                />
              </v-col>

              <!-- Aktifkan jika diperlukan -->

              <!--
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedBrandId"
              :items="listBrand"
              item-text="name"
              item-value="id"
              label="Brand"
              prepend-inner-icon="mdi-alpha-b-box-outline"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedColorId"
              :items="listColor"
              item-text="name"
              item-value="id"
              label="Warna"
              prepend-inner-icon="mdi-palette-outline"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedMaterialId"
              :items="listMaterial"
              item-text="name"
              item-value="id"
              label="Material"
              prepend-inner-icon="mdi-texture-box"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedUomId"
              :items="listUom"
              item-text="name"
              item-value="id"
              label="UOM"
              prepend-inner-icon="mdi-ruler"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="selectedTypeAssetId"
              :items="listTypeAsset"
              item-text="name"
              item-value="id"
              label="Tipe Asset"
              prepend-inner-icon="mdi-laptop"
              outlined
              dense
              clearable
            />
          </v-col>
          -->

              <v-col cols="12">
                <v-textarea
                  v-model="note"
                  label="Catatan"
                  placeholder="Tambahkan catatan jika diperlukan"
                  prepend-inner-icon="mdi-note-text-outline"
                  outlined
                  dense
                  rows="3"
                  auto-grow
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />

        <!-- FOOTER -->
        <v-card-actions class="px-6 py-4">
          <v-spacer />

          <v-btn
            text
            color="grey darken-1"
            :disabled="isSubmittingUpdate"
            @click="isDialogOpenEdit = false"
          >
            Batal
          </v-btn>

          <v-btn
            color="warning"
            dark
            depressed
            :disabled="!isFormValidUpdate"
            :loading="isSubmittingUpdate"
            @click="submitUpdate"
          >
            <v-icon left> mdi-content-save-edit-outline </v-icon>
            Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE -->
    <v-dialog v-model="isDialogOpenDelete" max-width="400px">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          Konfirmasi Hapus
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="text-body-2">
          Apakah Anda yakin ingin menghapus item
          <strong>{{ name }}</strong
          >?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="isDialogOpenDelete = false"> Batal </v-btn>

          <v-btn color="red" dark @click="submitDelete"> Hapus </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      tabItems: ["UOM"],
      isLoading: false,
      search: "",
      tab: 1,
      tableHeaders: [
        { text: "Nama", align: "center", value: "name" },
        { text: "Kategori", align: "center", value: "category_name" },
        // { text: "Brand", align: "center", value: "brand_name" },
        // { text: "Warna", align: "center", value: "color_name" },
        // { text: "Material", align: "center", value: "material_name" },
        // { text: "Tipe Asset", align: "center", value: "type_asset_name" },
        { text: "Catatan", align: "center", value: "note" },
        { text: "Status", align: "center", value: "is_active" },
        { text: "Dibuat Oleh", align: "center", value: "created_by_name" },
        { text: "Aksi", align: "center", sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        search: "",
      },
      total: null,
      list: [],
      listCategory: [],
      listBrand: [],
      listColor: [],
      listMaterial: [],
      listUom: [],
      listTypeAsset: [],
      isDialogOpenEdit: false,
      isDialogOpenDelete: false,
      isFormValidUpdate: false,
      isDialogOpenCreate: false,
      isFormValidCreate: false,
      selectedItem: null,
      id: null,
      name: null,
      // uom_id: null,
      note: null,
      selectedCategoryId: null,
      selectedBrandId: null,
      selectedColorId: null,
      selectedMaterialId: null,
      selectedUomId: null,
      selectedTypeAssetId: null,
    };
  },
  methods: {
    fetch() {
      store.dispatch("showLoading");
      const query = this.$route.query;
      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "name",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      api
        .get("/items", { params })
        .then(({ data }) => {
          this.list = data.data.data;
          this.total = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching parameters:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    fetchCategory() {
      api
        .get("/categories")
        .then(({ data }) => {
          this.listCategory = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchBrand() {
      api
        .get("/brand")
        .then(({ data }) => {
          this.listBrand = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching brand:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchColor() {
      api
        .get("/color")
        .then(({ data }) => {
          this.listColor = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching color:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchMaterial() {
      api
        .get("/material")
        .then(({ data }) => {
          this.listMaterial = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching material:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchUom() {
      api
        .get("/uom")
        .then(({ data }) => {
          this.listUom = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching uom:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    fetchTypeAsset() {
      api
        .get("/typeasset")
        .then(({ data }) => {
          this.listTypeAsset = data.data.data;
        })
        .catch((error) => {
          console.error("Error fetching typeasset:", error);
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    openDialogCreate() {
      // reset semua field form
      this.name = null;

      // reset validasi form (biar tombol disable lagi)
      this.isFormValidCreate = false;

      // buka dialog
      this.isDialogOpenCreate = true;
    },
    openDialogUpdate(item) {
      this.id = item.id;
      this.name = item.name;
      this.selectedCategoryId = item.category_id;
      // this.selectedBrandId = item.brand_id;
      // this.selectedColorId = item.color_id;
      // this.selectedMaterialId = item.material_id;
      // this.selectedUomId = item.uom_id;
      // this.selectedTypeAssetId = item.type_asset_id;
      this.note = item.note;
      this.isDialogOpenEdit = true;
    },
    openDialogDelete(params = null) {
      this.selectedItem = params;
      this.id = params.id;
      this.name = params.name;
      this.description = params.description;
      this.isDialogOpenDelete = true;
    },
    submitCreate() {
      store.dispatch("showLoading");

      const payload = {
        name: this.name,
        category_id: this.selectedCategoryId,
        // brand_id: this.selectedBrandId,
        // color_id: this.selectedColorId,
        // material_id: this.selectedMaterialId,
        // uom_id: this.selectedUomId,
        type_asset_id: this.selectedTypeAssetId,
        note: this.note,
      };

      api
        .post("/items", payload) // ⚠️ sesuaikan endpoint backend kamu
        .then((response) => {
          const message = response.data.message;

          this.fetch(); // refresh table
          this.isDialogOpenCreate = false;

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
        })
        .catch((error) => {
          let message = "Gagal menambahkan data!";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },
    submitUpdate() {
      store.dispatch("showLoading");
      const payload = {
        id: this.id,
        name: this.name,
        category_id: this.selectedCategoryId,
        // brand_id: this.selectedBrandId,
        // color_id: this.selectedColorId,
        // material_id: this.selectedMaterialId,
        // uom_id: this.selectedUomId,
        // type_asset_id: this.selectedTypeAssetId,
        note: this.note,
      };
      api
        .post("/items/update", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetch();
          this.isDialogOpenEdit = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },

    submitDelete() {
      store.dispatch("showLoading");

      api
        .post("/items/delete", {
          id: this.id,
        }) // ⚠️ sesuaikan endpoint backend
        .then((response) => {
          const message = response.data.message;

          this.fetch();
          this.isDialogOpenDelete = false;

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: true,
          });
        })
        .catch((error) => {
          let message = "Gagal menghapus data!";

          if (error.response) {
            message = error.response.data.message || message;
          } else {
            message = error.message || message;
          }

          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          store.dispatch("hideLoading");
        });
    },

    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.selectedDivisionId = parseInt(query.divisionId) || 0;
      this.selectedPositionId = parseInt(query.positionId) || 0;
      this.selectedSiteId = parseInt(query.siteId) || 0;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  mounted() {
    store.commit("setTitle", "Item");
    this.updatePagination(this.$route.query);
    this.fetchCategory();
    // this.fetchBrand();
    // this.fetchColor();
    // this.fetchMaterial();
    // this.fetchUom();
    // this.fetchTypeAsset();
  },
  watch: {
    pagination: {
      handler: "fetch",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(2),
td:nth-child(4),
td:nth-child(5) {
  text-align: center;
}
</style>
